<template>
    <div v-if="location" data-testid="mkt-location" class="mkt-location">
        <VJoyIcon name="location" :color="iconColor" />
        {{ location }}
    </div>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';
    import {useVariants} from '../../composables/useVariants';

    defineProps<{
        location: string | null;
    }>();

    const {icon: iconColor} = useVariants();
</script>

<style lang="scss">
    .mkt-location {
        display: flex;
        align-items: center;
        gap: var(--joy-core-spacing-1);
    }
</style>
